import { getParentOfType, types } from 'mobx-state-tree';
import Picture from './Picture';
import { Item } from './Item';
import { PricingStrategy } from './PricingStrategy';

export const Variations = types.model('variations', {
  id: types.string,
  itemId: types.string,
  title: types.optional(types.string,''),
  treeDepth: 1,
  status: types.optional(types.string,''),
  pictures: types.optional(types.array(Picture), []),
  ready: types.optional(types.boolean, false),
  pricingStrategy: types.maybe(PricingStrategy),
  sku: types.optional(types.string, '')
}).preProcessSnapshot(snapshot => ({
  title: snapshot.sku,
  status: '',
  id: snapshot.id,
  itemId: snapshot.itemId,
  treeDepth: 1,
  pictures: snapshot.variationSpecificPictures && snapshot.variationSpecificPictures.length ? snapshot.variationSpecificPictures.map(pic=>Picture.create({
    id: pic.id,
    url: pic.pictureUrl
  })) : [],
  pricingStrategy: snapshot.pricingStrategy
})).actions(self => ({
  afterCreate(){
    const actualParent = getParentOfType(self, Item);
    self.status = actualParent.status;
    self.ready = true;
  }
}));
